import React, { useEffect, useState } from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";
import { AiFillCaretRight, AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import SavePlusAccountComponent from "../../Components/SavePlusAccount/SavePlusAccountComponent";
import ContainsArea from "../../Components/ContainsArea/ContainsArea";

const IZBSmartChildEducationPlan = () => {
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-home-loan-banner.png";
  const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZBSmartChildEducationPlan.png";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const accountContent = "";

  
  const [openIndex, setOpenIndex] = useState(null);


  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const accordionData = [
    {
        title: "Eligibility",
        content: [
          "The INDO Smart Child is a life policy designed for Indo Zambia Bank individual customers who would like to make provision for their children’s future school fees. An individual needs to have an account with the bank in order to be able to buy this policy.",
        ],
    },
    {
      title: "Features/benefits",
      content: [
        "Handsome Maturity Benefit",
        "Maturity Bonus",
        "Death Benefit",
        "Waiver Of Premium on Death, Permanent Disability & Critical Illness",
        "Adequate Paid-Up Value",
        "Inflation Protection Benefit",
        "Guaranteed Surrender Value",
      ],
    },
    {
      title: "Conditions and Requirements",
      content: [
        "Policy Terms-Minimum term 5 years, Max 20",
        "Age Range(Policy holder)-Minimum entry age 18, Max 60",
        "Age Range(Beneficiaries)Max Child Age 16, Min 1",
        "Policy Fee K20.00",
        "Lapsation – policy lapses after 3 months of missed premiums. The policy can be reinstated withing 12 months of lapsation",
        "Assignments & Loans – N/A. Policy can not be used as collateral for loans",
        "Cancellation Calculated by percentage",
      ],
    },
    {
      title: "How to Apply",
      content: ['To apply now, email <a href="mailto:bancassurance@izb.co.zm">bancassurance@izb.co.zm</a> or call <a href="tel:8002">8002</a>'],
    }
  ];

  return (
    <>
       <section className="HouseOwnersInsuranceSection">
        <Breadcrumb Heading="IZB Smart Child Education Plan" img={BackgroundBrundcrumb} show={true} btnTxt="Apply Now" />
       </section>

       <SavePlusAccountComponent heading="IZB Smart Child Education Plan" subHeading="Know About" btnTxt="Apply Now" content={accountContent} img={img1} logo={true} />
       {/* <ContainsArea /> */}

        <section>
            <div className="container">
            <div className="row">
                <div className="col-xl-12 justify-content-center">
                <div className="faq-style1__content">
                    <ul className="accordion-box mt-2" style={{paddingBottom: "50px"}}>
                        {accordionData.map((item, index) => (
                            <li className="accordion block active-block" key={index}>
                                <div
                                    className="acc-btn active"
                                    style={{ backgroundColor: "#9E1B1E", backgroundSize: "20px" }}
                                    onClick={() => handleToggle(index)}
                                >
                                    <div className="icon-outer text-white">
                                         {openIndex === index ? <AiOutlineArrowRight /> :  <AiOutlineArrowUp />}
                                    </div>
                                    <h3 className="text-white">{item.title}</h3>
                                </div>
                                {openIndex === index && (
                                    <div className="acc-content current px-5">
                                        {item.content.map((point, idx) => (
                                            <p key={idx} className="">
                                                <AiFillCaretRight className="me-1 accordion-icon" />
                                                <span className="mt-1" dangerouslySetInnerHTML={{ __html: point }} />
                                            </p>
                                        ))}
                                    </div>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
                </div>
            </div>
            </div>
        </section>

       <AllAcountsSection />
    </>
  );
};

export default IZBSmartChildEducationPlan;